import ShiftDetailsLayout from "@/app/(app)/(crew)/home/[shift]/_layout";
export default ShiftDetailsLayout;
